import { all, put, call, takeEvery } from "redux-saga/effects";
import axios from "axios";
import * as actions from "./actions";


function* checkLogin(action) {
  const {
    credentials: { username, password },
  } = action.payload;

  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_GO_API_ENDPOINT}/auth/login`,
      {
        username,
        password,
      }
    );
    let {
      token,
      permission,
      status,
    } = res.data;

    if (status === "success") {
      let base64Url = token.split(".")[1];
      let base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
      let deToken = JSON.parse(window.atob(base64));

      yield call(() =>
        actions.storeCredentials(
          token,
          deToken,
          permission,
        )
      );
      yield put(
        actions.checkLogin.success(
          token,
          deToken,
          permission,
        )
      );

      window.location.href = "/saleorders"
    } else {
      yield put(
        actions.checkLogin.failure(
          "error",
          "data_not_complete",
          res.path_signup
        )
      );
    }
  } catch (err) {
    console.log("err:", err.message);
    if (err.message.indexOf("401") !== -1)
      yield put(
        actions.checkLogin.failure("error", "Invalid username or password")
      );
    else if (err.message.indexOf("503") !== -1)
      yield put(actions.checkLogin.failure("error", "Service Unavailable!"));
    else if (err.message.indexOf("502") !== -1)
      yield put(actions.checkLogin.failure("error", "Bad Gateway!"));
    else if (err.message.indexOf("504") !== -1)
      yield put(actions.checkLogin.failure("error", "Gateway Timeout!"));
    else yield put(actions.checkLogin.failure("error", "An error occurred. Please try again later"));
  }
}

export default function* watchAuthState() {
  yield all([
    takeEvery(actions.CHECK_LOGIN.REQUEST, checkLogin),
  ]);
}

export {
  checkLogin,
};